import { createActionTypes } from "@helpers/redux-helpers";

export const createConsentFormActionTypes = createActionTypes(
  "consent-form/create",
);

export const getConsentFormsActionTypes = createActionTypes(
  "consent-form/consent-forms/get",
);

export const getPortionConsentFormsActionTypes = createActionTypes(
  "consent-form/consent-forms/getPortion",
);

export const getReceivedFormsActionTypes = createActionTypes(
  "consent-form/received-consent-forms/get",
);

export const getPortionReceivedFormsActionTypes = createActionTypes(
  "consent-form/received-consent-forms/getPortion",
);

export const deleteConsentFormActionTypes = createActionTypes(
  "consent-form/delete",
);

export const editConsentFormNameActionTypes = createActionTypes(
  "consent-form/edit/formName",
);

export const signReceivedFormActionTypes = createActionTypes(
  "consent-form/sign-received-form",
);

export const rejectReceivedFormActionTypes = createActionTypes(
  "consent-form/reject-received-form",
);

export const assignFormActionTypes = createActionTypes(
  "consent-form/assign-form",
);
export const getNewSignConsentFormsCountActionTypes = createActionTypes(
  "consent-form/get-new-consent-forms-count",
);

export const setSigningConsentFormIdActionType =
  "consent-form/set/signing-consent-form-id";
